import { Action, createReducer, on } from '@ngrx/store';

import {
  initialState,
  entityEstadosRolAdapter,
  EntityEstadosRolState
} from './entity-estados-rol.state';
import {
  entityEstadosRolLoadFailure,
  entityEstadosRolLoadRequest,
  entityEstadosRolLoadSuccess,
} from './entity-estados-rol.actions';

const reducer = createReducer(
  initialState,
  // load
  on(entityEstadosRolLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityEstadosRolLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityEstadosRolLoadSuccess, (state, { items }) =>
    entityEstadosRolAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
);

export function entityEstadosRolReducer(
  state: EntityEstadosRolState | undefined,
  action: Action
) {
  return reducer(state, action);
}
